import { render, staticRenderFns } from "./other.vue?vue&type=template&id=3a37bd20"
import script from "./other.vue?vue&type=script&lang=js"
export * from "./other.vue?vue&type=script&lang=js"
import style0 from "./other.vue?vue&type=style&index=0&id=3a37bd20&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3a37bd20')) {
      api.createRecord('3a37bd20', component.options)
    } else {
      api.reload('3a37bd20', component.options)
    }
    module.hot.accept("./other.vue?vue&type=template&id=3a37bd20", function () {
      api.rerender('3a37bd20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/systemsettings/components/other.vue"
export default component.exports